<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="320px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="inputValue"
        prepend-icon="mdi-calendar-month"
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
      />
    </template>
    <v-card>
      <v-date-picker
        v-if="pickerStep === 'date'"
        v-model="internalDate"
        :locale="$i18n.locale"
        scrollable
        full-width
        @change="onDateSelected"
      />
      <v-time-picker
        v-else
        v-model="internalTime"
        format="24hr"
        full-width
        @change="onTimeSelected"
      />
    </v-card>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateTimePicker',
  inheritAttrs: false,
  props: {
    value: [String, Date],
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm'
    }
  },
  data () {
    return {
      menu: false,
      pickerStep: 'date',
      internalDate: null,
      internalTime: null,
      textValue: ''
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.textValue
      },
      set (val) {
        this.handleManualInput(val)
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.syncFromValue(val)
      }
    },
    menu (isOpen) {
      if (isOpen) {
        this.pickerStep = 'date'
      }
    }
  },
  methods: {
    parseValue (val) {
      if (!val && val !== 0) return null
      if (val instanceof Date) return moment(val)
      const parsed = moment(val, this.format, true)
      if (parsed.isValid()) return parsed
      const fallback = moment(val)
      return fallback.isValid() ? fallback : null
    },
    syncFromValue (val) {
      const parsed = this.parseValue(val)
      if (parsed?.isValid()) {
        this.setFromMoment(parsed)
        this.textValue = parsed.format(this.format)
      } else {
        this.internalDate = null
        this.internalTime = null
        this.textValue = ''
      }
    },
    setFromMoment (m) {
      this.internalDate = m.format('YYYY-MM-DD')
      this.internalTime = m.format('HH:mm')
    },
    handleManualInput (val) {
      this.textValue = val
      if (!val) {
        this.internalDate = null
        this.internalTime = null
        this.$emit('input', null)
        this.$emit('change', null)
        return
      }
      const parsed = moment(val, this.format, true)
      if (!parsed.isValid()) return
      this.setFromMoment(parsed)
      const formatted = parsed.format(this.format)
      this.textValue = formatted
      this.$emit('input', formatted)
      this.$emit('change', formatted)
    },
    onDateSelected (date) {
      this.internalDate = date
      this.pickerStep = 'time'
    },
    onTimeSelected (time) {
      this.internalTime = time
      this.commitValue()
    },
    commitValue () {
      if (!this.internalDate || !this.internalTime) return
      const combined = moment(
        `${this.internalDate} ${this.internalTime}`,
        'YYYY-MM-DD HH:mm',
        true
      )
      if (!combined.isValid()) return
      const formatted = combined.format(this.format)
      this.textValue = formatted
      this.$emit('input', formatted)
      this.$emit('change', formatted)
      this.menu = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
